import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import { fromLonLat } from 'ol/proj'
import getPinStyle from '../getPinStyle'
import { createGeoJsonLayer } from '../createGeoJsonLayer'
import LayerGroup from 'ol/layer/Group'
import { getAfaCodeFormat } from 'modules/Geo/utils/afacode/getAfaCodeFormat'
// import { findLayerByName } from '../findLayerByName'

export function createAFACodePinLayer({ pin }: any) {
  // PIN
  const pinFeature = new Feature({
    geometry: new Point(fromLonLat([pin.lon, pin.lat])),
  })

  pinFeature.setProperties({
    id: pin.id,
    type: pin.type,
    data: pin.data,
    variant: 'label',
    label: getAfaCodeFormat(pin.id)
  })

  pinFeature.setStyle(getPinStyle(pin.type, {variant: 'label', label: getAfaCodeFormat(pin.id)}))

  const pinLayer = new VectorLayer({
    source: new VectorSource({
      features: [pinFeature],
    }),
  })

  pinLayer.set('name', `AFACODE_PIN_${pin.id}`)

  // SHAPE (se existir geometry)
  const layers: VectorLayer[] = [pinLayer]

  if (pin.data?.geometry) {
    const shapeLayer = createGeoJsonLayer(pin.data.geometry, `AFACODE_SHAPE_${pin.id}`)
    layers.push(shapeLayer)
  }

  // Agrupa ambos em um LayerGroup
  const layerGroup = new LayerGroup({
    layers,
  })

  layerGroup.set('name', `AFACODE_GROUP_${pin.id}`)

  return layerGroup
}
